import React, { useState } from "react";
import "./Contact.css";
import { useLanguage } from "../LanguageContext";

const Contact = () => {
  const { language } = useLanguage();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // For a static site, we can use mailto: to send the data via the user's mail client
    const subject = `Contact Portfolio - ${formData.name}`;
    const body = `Nom: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`;
    window.location.href = `mailto:hajar.auteure@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="contact-title">
          {language === 'ar' ? 'تواصل معي' : language === 'fr' ? 'Contactez-moi' : 'Drop us a line!'}
        </h2>
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input 
              type="text" 
              name="name" 
              placeholder={language === 'ar' ? 'الاسم' : language === 'fr' ? 'Nom' : 'Name'} 
              value={formData.name}
              onChange={handleChange}
              required 
            />
          </div>
          <div className="form-group">
            <input 
              type="email" 
              name="email" 
              placeholder={language === 'ar' ? 'البريد الإلكتروني' : language === 'fr' ? 'Email*' : 'Email*'} 
              value={formData.email}
              onChange={handleChange}
              required 
            />
          </div>
          <div className="form-group">
            <textarea 
              name="message" 
              placeholder={language === 'ar' ? 'الرسالة' : language === 'fr' ? 'Message' : 'Message'} 
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="contact-submit-btn">
            {language === 'ar' ? 'إرسال' : language === 'fr' ? 'ENVOYER' : 'SEND'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
